import React, { useState, useEffect } from 'react';
import './App.css';
import TrackerApp from './components/TrackerApp';
// Match your actual component structure

function App() {
  return (
    <div className="App">
      <TrackerApp />
    </div>
  );
}

export default App;